import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';

import { getOnboardingSteps } from '../helpers/Onboarding';
import { getUserSetting } from '../helpers/Settings';
import { getSidebarCurrentRoute } from '../helpers/App';

const SidebarSpaceUsage = ({ location, profile }) => {
  const intl = useIntl();

  const onboardingDismissed = getUserSetting('onboarding_dismissed');
  const onboardingSteps = getOnboardingSteps();
  const userSteps = getUserSetting('onboarding_steps');
  const userStepsCompleted = userSteps ?
    userSteps.filter(s => s.completed && onboardingSteps.includes(s.slug)) : [];

  const currentSidebarRoute = getSidebarCurrentRoute(location);

  if (onboardingSteps.length === 0 ||
    userStepsCompleted.length === onboardingSteps.length) return null;

  if (currentSidebarRoute === 'dashboard') return null;

  if (!profile || !profile.client || onboardingDismissed) return null;

  return (
    <Link to="/" className="sidebar-onboarding-progress">
      <span className="sidebar-onboarding-progress-title">
        {intl.formatMessage({ defaultMessage: 'Onboarding Checklist' })}
      </span>
      <span>
        {intl.formatMessage(
          { defaultMessage: '{userCompleted} of {totalCompleted}' },
          { userCompleted: userStepsCompleted.length, totalCompleted: onboardingSteps.length },
        )}
        {' '}
        {intl.formatMessage({ defaultMessage: 'Completed' })}
      </span>
    </Link>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

SidebarSpaceUsage.propTypes = {
  location: PropTypes.object.isRequired,
  profile: PropTypes.object,
};

SidebarSpaceUsage.defaultProps = {
  profile: null,
};

export default withRouter(connect(mapStateToProps)(SidebarSpaceUsage));
